import React, { Component } from "react";

const title = "Trusted by BAT members";
const subtitle = "How Does It Work?";

let WorkListContent = [
  {
    imgUrl: "./assets/images/bat-img/user-heart.svg",
    imgAlt: "work thumb",
    // step: "step",
    // stepCount: "01",
    title: "Best Matches",
    // desc: "Continua actualize ailers through robu and sertively concepze standards compliant commerce after technica sound.",
  },
  {
    imgUrl: "./assets/images/bat-img/user-profile.svg",
    imgAlt: "work thumb",
    // step: "step",
    // stepCount: "02",
    title: "Verified Profiles",
    // desc: "Continua actualize ailers through robu and sertively concepze standards compliant commerce after technica sound.",
  },
  {
    imgUrl: "./assets/images/bat-img/user-privacy.svg",
    imgAlt: "work thumb",
    // step: "step",
    // stepCount: "03",
    title: "100% Privacy",
    // desc: "Continua actualize ailers through robu and sertively concepze standards compliant commerce after technica sound.",
  },
];

const WorkSection = () => {
  return (
    <section className="trusted-section padding-tb bg-flower-img bottom">
      <div className="container">
        <div className="section-header">
          <h2 data-description="title">{title}</h2>
        </div>
        <div className="section-wrapper">
          <div className="row justify-content-center g-5">
            {WorkListContent.map((val, i) => (
              <div className="col-lg-4 col-sm-6 col-12 px-4" key={i}>
                <div className="trusted-container">
                  <div className="trusted-wrapper text-center">
                    <div className="trusted-icons">
                      <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                    </div>
                    <div className="trusted-content">{val.title}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkSection;
